// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TrophyFilledSvg from "@ant-design/icons-svg/es/asn/TrophyFilled";
import AntdIcon from '../components/AntdIcon';

var TrophyFilled = function TrophyFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: TrophyFilledSvg
  }));
};

TrophyFilled.displayName = 'TrophyFilled';
export default React.forwardRef(TrophyFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/TrophyFilled.js
// module id = 1959
// module chunks = 0